export default __webpack_public_path__ + "static/media/imdb-icon.211e7b09.png";